import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import printJS from "print-js";
import { useAuth } from "hooks/useAuth";

const PrintCustomBookingActivity = ({
  booking,
  refetch,
  onSuccess,
  onError,
  isCustom = false,
}) => {
  const printRef = useRef();
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const { user } = useAuth();
  const today = new Date();
  const printDate = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const printTime = today.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  useEffect(() => {
    if (booking?.activities?.length && isCustom) {
      setSelectedIndexes(booking.activities.map((_, i) => i)); // default semua dicentang
    }
  }, [booking, isCustom]);

  const handleCheckbox = (i) => {
    setSelectedIndexes((prev) =>
      prev.includes(i) ? prev.filter((item) => item !== i) : [...prev, i]
    );
  };

  const handlePrint = () => {
    if (isCustom && selectedIndexes.length === 0) {
      Swal.fire(
        "No Activity Selected",
        "Please select at least one activity.",
        "warning"
      );
      return;
    }

    printJS({
      printable: printRef.current.innerHTML,
      type: "raw-html",
      targetStyles: ["*"],
      onPrintDialogClose: () => {
        Swal.fire({
          title: "Printed",
          text: "Custom activity printed successfully!",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        if (onSuccess) onSuccess();
        if (refetch) refetch();
      },
    });
  };

  const filteredActivities = isCustom
    ? booking.activities.filter((_, i) => selectedIndexes.includes(i))
    : booking.activities;

  return (
    <div>
      {/* {isCustom && (
        <div className="mb-3">
          <h5>Select Activities to Print:</h5>
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {booking.activities.map((activity, index) => (
              <li key={index}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedIndexes.includes(index)}
                    onChange={() => handleCheckbox(index)}
                  />{" "}
                  {activity.activity} (Qty: {activity.qty})
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
      <hr /> */}
      {isCustom && (
        <div className="mb-4">
          <h5 className="mb-2">Please select activities to print:</h5>
          <div className="d-flex flex-column gap-2">
            {booking.activities.map((activity, index) => (
              <div key={index} className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`activity-${index}`}
                  checked={selectedIndexes.includes(index)}
                  onChange={() => handleCheckbox(index)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`activity-${index}`}
                >
                  {activity.activity}{" "}
                  <span className="text-muted">(Qty: {activity.qty})</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* <pre>{JSON.stringify(booking, null, 2)}</pre> */}

      <button className="btn btn-primary mb-3" onClick={handlePrint}>
        Print Selected Activities
      </button>

      <div ref={printRef} style={{ display: "none" }}>
        <style>
          {`
          @media print {
            body {
              font-family: Arial, sans-serif;
              width: 58mm;
              padding: 5px;
            }
            .receipt {
              text-align: center;
              width: 100%;
              font-size: 14px;
            }
            .border-dashed {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
            table {
              width: 100%;
              font-size: 14px;
              border-collapse: collapse;
            }
            td, th {
              padding: 4px 0;
              text-align: left;
            }
            .right {
              text-align: right;
            }
            .center {
              text-align: center;
            }
          }
          `}
        </style>

        {/* Logo */}
        <div className="receipt">
          <img src="/Kuber.jpeg" alt="Logo" style={{ width: "50px" }} />
          <p>
            <strong>KUBER BALI ADVENTURE</strong>
          </p>
          <p>Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
          <div className="border-dashed"></div>
        </div>

        <table>
          <tbody>
            <tr>
              <td>
                <strong>HOST</strong>
              </td>
              <td className="right" style={{ textTransform: "uppercase" }}>
                {user.name}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Code</strong>
              </td>
              <td className="right">{booking.code}</td>
            </tr>
            <tr>
              <td>
                <strong>Date</strong>
              </td>
              <td className="right">{booking.reservation_date}</td>
            </tr>
            <tr>
              <td>
                <strong>Print Date</strong>
              </td>
              <td className="right">{printDate}</td>
            </tr>
            <tr>
              <td>
                <strong>Print Time</strong>
              </td>
              <td className="right">{printTime}</td>
            </tr>
            <tr>
              <td>
                <strong>Guest</strong>
              </td>
              <td className="right">{booking.guest_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Hotel</strong>
              </td>
              <td className="right">{booking.customer?.nationality || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Agent</strong>
              </td>
              <td className="right">{booking.agent?.name || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Driver</strong>
              </td>
              <td className="right">{booking.driver || "-"}</td>
            </tr>
            {/* transport */}
            <tr>
              <td>
                <strong>Transport</strong>
              </td>
              <td className="right">{booking.guest_transport || "-"}</td>
            </tr>
          </tbody>
        </table>

        <div className="border-dashed"></div>
        {/* Track */}
        <h2 className="center text-center align-middle m-0 p-0">
          {booking.track === "A" ? "PREMIUM" : "REGULAR"}
        </h2>
        {/* Detail Produk */}

        <h4>Activities</h4>
        <table>
          <thead>
            <tr>
              <th>Activity</th>
              <th className="right">Qty</th>
            </tr>
          </thead>
          <tbody>
            {filteredActivities.map((activity, index) => (
              <tr key={index}>
                <td style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {activity.activity}
                </td>
                <td className="right">{activity.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* print json activity */}
        {/* Detail Pembayaran */}
        <div className="border-dashed"></div>
        <table>
          <tbody>
            {/* payment method */}

            <tr>
              <td>
                <strong>Total Guest</strong>
              </td>
              <td className="right">{booking.guest_pax}</td>
            </tr>
            <tr>
              <td>
                <strong>Payment Method</strong>
              </td>
              <td className="right">{booking.payment_method?.name || "-"}</td>
            </tr>
            {(() => {
              const subtotal = filteredActivities.reduce(
                (acc, curr) =>
                  acc + parseFloat(curr.price || 0) * parseInt(curr.qty || 0),
                0
              );

              const taxPercentage = parseFloat(booking.tax || 0);
              const taxAmount = (subtotal * taxPercentage) / 100;
              const totalPaid = subtotal + taxAmount;

              return (
                <>
                  <tr>
                    <td>
                      <strong>Sub Total</strong>
                    </td>
                    <td className="right">
                      Rp. {subtotal.toLocaleString("id-ID")}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        Tax {taxPercentage.toLocaleString("id-ID")}%
                      </strong>
                    </td>
                    <td className="right">
                      Rp. {taxAmount.toLocaleString("id-ID")}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Total Paid</strong>
                    </td>
                    <td className="right">
                      Rp. {totalPaid.toLocaleString("id-ID")}
                    </td>
                  </tr>
                </>
              );
            })()}
          </tbody>
        </table>

        <div className="border-dashed"></div>
        {/* ttd tamu */}
        <div className="receipt" style={{ marginTop: 32, marginBottom: 32 }}>
          <p className="receipt">
            <strong>Signature of Guest</strong>
          </p>
          <div style={{ height: 60 }}></div>
          <p className="receipt mt-4" style={{ marginTop: 32 }}>
            ({booking.guest_name})
          </p>
        </div>
        <div className="border-dashed"></div>
        <p className="text-center">Thank you for your booking!</p>
      </div>
    </div>
  );
};

export default PrintCustomBookingActivity;
